export const formikProps = {
    formik: {
        onChangeValidate: false,
        onBlurValidate: false,
    },
    initialValues: {
        email: '',
    },
};
